/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorModel
 */
export interface ErrorModel {
    /**
     * 
     * @type {number}
     * @memberof ErrorModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorModel
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorModel
     */
    message?: string;
}

/**
 * Check if a given object implements the ErrorModel interface.
 */
export function instanceOfErrorModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ErrorModelFromJSON(json: any): ErrorModel {
    return ErrorModelFromJSONTyped(json, false);
}

export function ErrorModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ErrorModelToJSON(value?: ErrorModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'error': value.error,
        'message': value.message,
    };
}

